<!--
     <Barometer
       :entries="{avg: [12, 14.2], min: [4, 5.2], max: [20, 20.5]}"
       :title="my_title"
       :start_date="my_start_date"
       :precision="day"
     />
-->


<template>
  <highcharts
    class="hc"
    :options="chartOptions"
    ref="chart"
  >
  </highcharts>
</template>

<script>
 /* import utils from '@/utils'
  */
 export default {
   name: 'Pressió',

   props: [
     'entries',
     'title',
     'start_date',
     'precision',
   ],

   data: (() => ({
   })),

   computed: {
     chartOptions() {
       return {
         title: {
           text: this.title
         },

         chart: {
           backgroundColor: 'transparent',
         },

         credits: {
           enabled: false
         },

         yAxis: {
           title: {
             text: 'Hectopascals'
           },
           min: Math.min(...this.entries.min) - 5,
         },

         xAxis: {
           type: 'datetime',
           title: {
             /* text: 'Data' */
           },
         },

         plotOptions: {
           series: {
             label: {
               connectorAllowed: false
             },
             pointStart: this.start_date,
             pointIntervalUnit: this.precision,
             pointPlacement: 'between',
           }
         },

         series: [{
           name: 'Pressió mitjana',
           data: this.entries.avg,
           type: 'area',
           color: '#880016',
           fillColor: {
             linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
             stops: [
               [0, '#880016'],
               [
                 1,
                 '#88001620'
               ]
             ]
           },
           tooltip: {
             valueSuffix: ' hPa'
           },
           states: {
             inactive: {
               opacity: 1
             }
           }
         }, {
           name: 'Pressió mínima',
           data: this.entries.min,
           color: '#3659c1',
           tooltip: {
             valueSuffix: ' hPa'
           },
           states: {
             inactive: {
               opacity: 1
             }
           }
         }, {
           name: 'Pressió màxima',
           data: this.entries.max,
           color: '#c18e37',
           tooltip: {
             valueSuffix: ' hPa'
           },
           states: {
             inactive: {
               opacity: 1
             }
           }
         }],

         responsive: {
           rules: [{
             condition: {
               maxWidth: 500
             },
             chartOptions: {
               legend: {
                 layout: 'horizontal',
                 align: 'center',
                 verticalAlign: 'bottom'
               }
             }
           }]
         }
       };
     },
   },

   mounted() {
   },

   methods: {
   },
 }
</script>
